import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import Modal from 'react-modal';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa'; // Import icons
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Set the app element for accessibility (for screen readers)
Modal.setAppElement('#root');

const Gallery = () => {
    const [imgUrls, setImgUrls] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedImg, setSelectedImg] = useState(null);

    useEffect(() => {
        fetch('/data/gallary.json')
            .then(res => res.json())
            .then(data => {
                setImgUrls(data);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    }, []);

    const PrevArrow = ({ onClick }) => (
        <div
            className="absolute top-1/2 left-4 transform -translate-y-1/2 text-white text-2xl cursor-pointer z-10 bg-transparent p-2 rounded-full hover:bg-gray-700 transition-all duration-300"
            onClick={onClick}
        >
            {"❮"}
        </div>
    );

    const NextArrow = ({ onClick }) => (
        <div
            className="absolute top-1/2 right-4 transform -translate-y-1/2 text-white text-2xl cursor-pointer z-10 bg-transparent p-2 rounded-full hover:bg-gray-700 transition-all duration-300"
            onClick={onClick}
        >
            {"❯"}
        </div>
    );

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3, // Shows 3 images at a time
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        prevArrow: <PrevArrow />, // Custom left arrow
        nextArrow: <NextArrow />, // Custom right arrow
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    return (
        <div className="my-16 container mx-auto relative bg-green-100 py-12">
            <h1 className="text-center text-3xl text-secondary font-bold pb-12">GALLERY</h1>

            {loading ? (
                <div className="flex justify-center items-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500"></div>
                </div>
            ) : (
                <Slider {...settings} className="space-x-4">
    {imgUrls.map((img, i) => (
        <div key={i} className="px-2"> {/* Adds space between slides */}
            <div 
                className="relative w-full h-64 flex justify-center items-center bg-gray-200 overflow-hidden group cursor-pointer"
                onClick={() => {
                    setSelectedImg(img);
                    setModalIsOpen(true);
                }}
            >
                {/* Image */}
                <img 
                    src={img} 
                    alt="Gallery img" 
                    className="w-full h-full object-cover rounded-lg transition-transform duration-300 group-hover:scale-105"
                />

                {/* Gradient Overlay on Hover */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg"></div>
            </div>
        </div>
    ))}
</Slider>

            )}

            {/* Full View Modal */}
            <Modal 
                isOpen={modalIsOpen} 
                onRequestClose={() => setModalIsOpen(false)}
                className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-80"
            >
                {selectedImg && (
                    <div className="relative p-4 max-w-4xl w-full">
                        {/* Close Button */}
                        <button 
                            className="absolute top-2 right-2 text-white text-3xl" 
                            onClick={() => setModalIsOpen(false)}
                        >
                            &times;
                        </button>
                        
                        {/* Full Image */}
                        <img 
                            src={selectedImg} 
                            alt="Full view" 
                            className="w-full max-h-screen object-contain rounded-lg"
                        />
                    </div>
                )}
            </Modal>
        </div>
    );
};

export default Gallery;
